/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeApiRequest } from "../util";

export const LMRUsersAdd = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/mc-users/ic-add`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const MCUsersAdd = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/lmr-users/ic-add`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const LMRGroupsAdd = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/mc-groups/ic-add`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const MCGroupsAdd = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/lmr-groups/ic-add`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const LMRUsersEdit = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/mc-users/ic-edit`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const MCUsersEdit = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/lmr-users/ic-edit`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const LMRGroupsEdit = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/mc-groups/ic-edit`,
    method: "POST",
    body: JSON.stringify({ "MAPPED-MCPTT-GID": data }),
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};

export const MCGroupsEdit = async ({
  data,
  org,
  token,
}: {
  data: any;
  org: string;
  token?: string | null;
}) => {
  const res = await makeApiRequest<{ Error: string }>({
    path: `/api/v1/lmr-groups/ic-edit`,
    method: "POST",
    body: data,
    token,
    org,
  });
  if (res.Error) {
    throw new Error(res.Error);
  }
};
